import React from 'react';
import { Backdrop, Box, Button, Grid, Typography } from '@mui/material';
import TextField from '../SanitizedTextField/SanitizedTextField';
import AppLoader from '../AppLoader/AppLoader';
import StepProgressBar from '../StepProgressBarForm/StepProgressBar';
import Error from '../error/error';
import { REUPLOAD_STEP_PAGE_NAME } from './reuploadDocumentUi';
import '../../style/reuploadDocumentsPage.scss';

const ReuploadDocumentsPageLayout = ({
    pageTitle,
    statusBar,
    stepPageName = REUPLOAD_STEP_PAGE_NAME,
    dialogRowData,
    onSubmit,
    onCancel,
    cancelLabel = 'Cancel',
    submitLabel = 'Submit',
    submitDisabled = false,
    documentsLoading = false,
    viewBackdrop = false,
    error,
    onErrorClose,
    children,
    extraApplicationFields = null,
}) => {
    if (documentsLoading) {
        return (
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }} open>
                <AppLoader />
            </Backdrop>
        );
    }

    return (
        <>
            <Grid container className="reupload-page" sx={{ width: '100%', maxWidth: '100%' }}>
                <Box className="reupload-container" sx={{ width: '100%', maxWidth: '100%' }}>
                    <h3 className="heading reupload-page-title">{pageTitle}</h3>
                    <div className="reupload-stepper-wrap">
                        <StepProgressBar array={statusBar} pageName={stepPageName} />
                    </div>

                    <form onSubmit={onSubmit} noValidate className="reupload-form">
                        <div className="section-card section-card--accent">
                            <div className="section-title">Application Details</div>
                            <Grid container spacing={1} className="container">
                                <Grid item xs={12} sm={6} md={4}>
                                    <div className="field-wrap">
                                        <Typography className="fieldLabel">Application Id</Typography>
                                        <TextField
                                            value={dialogRowData?.applicationId || ''}
                                            disabled
                                            fullWidth
                                            size="small"
                                            className="textInputField1"
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <div className="field-wrap">
                                        <Typography className="fieldLabel">Reference Number</Typography>
                                        <TextField
                                            value={dialogRowData?.referenceNo || dialogRowData?.refNo || '-'}
                                            disabled
                                            fullWidth
                                            size="small"
                                            className="textInputField1"
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <div className="field-wrap">
                                        <Typography className="fieldLabel">Applicant Name</Typography>
                                        <TextField
                                            value={dialogRowData?.name || dialogRowData?.applicantName || '-'}
                                            disabled
                                            fullWidth
                                            size="small"
                                            className="textInputField1"
                                        />
                                    </div>
                                </Grid>
                                {extraApplicationFields}
                            </Grid>
                        </div>

                        <div className="section-card section-card--docs">
                            <div className="section-title">Documents</div>
                            {children}
                        </div>

                        {error ? (
                            <div className="reupload-alert-wrap">
                                <Error
                                    error={error}
                                    onClose={onErrorClose}
                                    backgroundColor="#FFC0CB"
                                    textColor="#bb0303"
                                    iconColor="#bb0303"
                                />
                            </div>
                        ) : null}

                        <div className="submit-area">
                            <Button
                                type="button"
                                variant="outlined"
                                className="reupload-cancel-btn"
                                onClick={onCancel}
                            >
                                {cancelLabel}
                            </Button>
                            <Button
                                className="submit-btn"
                                variant="contained"
                                type="submit"
                                disabled={submitDisabled}
                            >
                                {submitLabel}
                            </Button>
                        </div>
                    </form>
                </Box>
            </Grid>

            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }} open={viewBackdrop}>
                <AppLoader />
            </Backdrop>
        </>
    );
};

export default ReuploadDocumentsPageLayout;
